/*
 * LK Popular Search — behavior for the header search box.
 * Shows the popular-searches panel + dim overlay when a search input
 * (input[name="q"], any instance on the page) is focused and empty,
 * hides it on blur/Escape/typing, and wires the suggestion buttons to
 * fill the input and trigger predictive search. Paired with
 * assets/lk-popular-search.css and the markup added in
 * sections/header.liquid. Added for Lisa Kookt.
 *
 * De koptekst 'Populaire zoekopdrachten' wordt hier bij het laden gezet
 * (de bron in header.liquid is hardgecodeerd). Gebeurt terwijl het paneel
 * nog verborgen is, dus zonder zichtbare flikkering.
 */
document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('[data-lk-search-overlay]');
  var panel = document.querySelector('[data-lk-popular-searches]');
  var inputs = document.querySelectorAll('input[name="q"]');
  var blurTimeout;
  var activeField = null;
  var svgNS = 'http://www.w3.org/2000/svg';

  var titleEl = panel ? panel.querySelector('.lk-popular-searches__title') : null;
  if (titleEl) { titleEl.textContent = 'Populaire zoekopdrachten'; }

  function enhanceItems() {
    document.querySelectorAll('.lk-popular-searches__item').forEach(function (btn) {
      if (btn.hasAttribute('data-lk-enhanced')) return;
      btn.setAttribute('data-lk-enhanced', 'true');
      var label = btn.textContent.trim();
      btn.textContent = '';
      var svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('class', 'icon icon-search');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('role', 'presentation');
      var use = document.createElementNS(svgNS, 'use');
      use.setAttribute('href', '#icon-search');
      svg.appendChild(use);
      var span = document.createElement('span');
      span.textContent = label;
      btn.appendChild(svg);
      btn.appendChild(span);
    });
  }

  function positionPanel(input) {
    if (!panel) return;
    var field = input.closest('.field') || input.closest('form');
    if (!field) return;
    activeField = field;
    var rect = field.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.left = rect.left + 'px';
    panel.style.width = rect.width + 'px';
    panel.style.top = rect.bottom + 'px';
  }

  function reposition() {
    if (panel && !panel.hidden && activeField) {
      var rect = activeField.getBoundingClientRect();
      panel.style.left = rect.left + 'px';
      panel.style.width = rect.width + 'px';
      panel.style.top = rect.bottom + 'px';
    }
  }

  function showPanel(input) {
    if (panel) {
      positionPanel(input);
      panel.hidden = false;
    }
    document.body.classList.add('lk-search-active');
  }

  function hidePanel() {
    if (panel) panel.hidden = true;
    document.body.classList.remove('lk-search-active');
    activeField = null;
  }

  enhanceItems();

  inputs.forEach(function (input) {
    input.addEventListener('focus', function () {
      clearTimeout(blurTimeout);
      if (input.value === '') {
        showPanel(input);
      } else {
        document.body.classList.add('lk-search-active');
      }
    });

    input.addEventListener('input', function () {
      if (input.value === '') {
        if (document.body.classList.contains('lk-search-active')) {
          showPanel(input);
        }
      } else if (panel) {
        panel.hidden = true;
      }
    });

    input.addEventListener('blur', function () {
      blurTimeout = setTimeout(function () {
        if (input.value === '') {
          hidePanel();
        }
      }, 150);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hidePanel();
        input.blur();
      }
    });
  });

  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, true);

  document.querySelectorAll('.lk-popular-searches__item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var term = btn.getAttribute('data-lk-term');
      var input = btn.closest('form') ? btn.closest('form').querySelector('input[name="q"]') : (inputs[0] || null);
      if (!input) return;
      input.value = term;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      if (panel) panel.hidden = true;
      input.focus();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      inputs.forEach(function (input) {
        input.blur();
      });
      hidePanel();
    });
  }
});
